import React from 'react';

import Typography from '../../../../library/typography/typography';

import './product-code.scss';

interface ProductCodeProps {
  code?: string;
}

function ProductCode(props: ProductCodeProps) {
  const { code } = props;

  if (!code) {
    return null;
  }

  return (
    <Typography className="product-code" styleName="code" tag="span">
      Item #{code}
    </Typography>
  );
}

export default ProductCode;
